import { LockClosed } from 'components/Icons';
import {
  NoAccessContainer,
  NoAccessDesc,
  NoAccessTitle,
} from './NoAccessStyles';
import { Redirect } from 'react-router-dom';

export const NoAccess = () => {
  const hasAccess = window.sessionStorage.getItem('hasAccess');

  return hasAccess === 'true' ? (
    <Redirect to='/' />
  ) : (
    <NoAccessContainer>
      <NoAccessTitle>Access Denied</NoAccessTitle>
      <NoAccessDesc>
        You don’t have access to this application.
        <br />
        Contact an administrator to get access.
      </NoAccessDesc>
      <LockClosed
        hoverCursor='default'
        className='pl-2 pe-none'
        size='80px'
        fill='#8795A1'
      />
    </NoAccessContainer>
  );
};
